import { useMutation, useQueryClient } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { ProfileDto } from "../types/dto";

import { contactsSearchProfilesQueryKeys } from "./queryKeyFactory";

export const useDeleteContactProfileMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<void, Error, ProfileDto["id"]>({
        mutationFn: (id) => salesApiService.contactsSearchProfiles.deleteProfile(id),
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: contactsSearchProfilesQueryKeys.allProfiles() });
        },
    });
};
